/**
 * Body scroll lock met scrollbar-compensatie.
 *
 * Voorkomt content-shift wanneer de scrollbar verdwijnt door
 * `overflow: hidden` op `<body>`. Meet de scrollbar-breedte op
 * lock-moment en compenseert via `padding-right`. Werkt idempotent:
 * op macOS met overlay-scrollbars is de gemeten breedte 0 en heeft
 * de padding geen zichtbaar effect.
 *
 * **Nested lock support**: `lockCount` houdt bij hoeveel consumers
 * (drawer, modal, mobile menu, lightbox, …) momenteel scroll willen
 * blokkeren. Pas wanneer alle consumers `unlockScroll()` hebben
 * aangeroepen wordt de body weer scrollable. Eerste lock captureert
 * de originele `padding-right` zodat we die bij unlock-0 terugzetten.
 *
 * Herbruikbaar: archive drawer is de eerste consumer,
 * toekomstige modals/menu's gebruiken dezelfde utility.
 *
 * @module modules/scroll-lock
 */

let lockCount = 0;
let originalPaddingRight = '';

/**
 * Vergrendel body scroll. Idempotent per consumer — roep
 * `unlockScroll()` exact even vaak aan als `lockScroll()` om de
 * lock weer op te heffen.
 */
export function lockScroll() {
    lockCount++;
    if (lockCount > 1) return;

    const scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;
    const currentPadding = parseInt(getComputedStyle(document.body).paddingRight, 10) || 0;
    originalPaddingRight = document.body.style.paddingRight;
    document.body.style.overflow = 'hidden';
    document.body.style.paddingRight = `${currentPadding + scrollbarWidth}px`;
}

/**
 * Verlaag de lock-counter. Pas bij 0 wordt de body weer scrollable
 * en de originele `padding-right` hersteld.
 */
export function unlockScroll() {
    lockCount -= 1;
    if (lockCount > 0) return;
    lockCount = 0;

    document.body.style.overflow = '';
    document.body.style.paddingRight = originalPaddingRight;
}
